import { render, staticRenderFns } from "./OrgHomeStatsDemands.vue?vue&type=template&id=7c4b0c3a&"
import script from "./OrgHomeStatsDemands.vue?vue&type=script&lang=js&"
export * from "./OrgHomeStatsDemands.vue?vue&type=script&lang=js&"
import style0 from "./OrgHomeStatsDemands.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports